export default __webpack_public_path__ + "static/resume-preview-647396c55f2c067f2512bf7591e18348.jpg";